import {Component, inject, model, OnInit, signal, ViewChild} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputComponent, InputOptions, SwitchComponent, SwitchOptions} from "@shared/components";
import {APIService} from '@core/services';
import {Subject, takeUntil} from 'rxjs';
import {InputModes, InputTypes} from '@core/enums';
import {APIOptions} from '@core/classes/api-options';
import {VaccinationCoding} from '@core/classes/other/vaccination-coding';

@Component({
  selector: 'ncp-vaccines-search',
  imports: [
    FormsModule,
    InputComponent,
    ReactiveFormsModule,
    SwitchComponent
  ],
  templateUrl: './vaccines-search.component.html',
  styleUrl: './vaccines-search.component.scss',
})
export class VaccinesSearchComponent implements OnInit {
  @ViewChild('searchInput') public searchInput!: InputComponent
  private readonly apiService = inject(APIService)

  protected vaccineSwitchOptions = signal<SwitchOptions>({});
  protected brandNameInputOptions = signal<InputOptions>({});
  protected descriptionInputOptions = signal<InputOptions>({});

  protected data = model<any>();
  protected isChecked: boolean = true;

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected formGroup: FormGroup = new FormGroup({
    brandNameSearch: new FormControl<string>(''),
    descriptionSearch: new FormControl<string>(''),
  });

  get brandNameSearch() {
    return this.formGroup.get('brandNameSearch') as FormControl;
  }

  get descriptionSearch() {
    return this.formGroup.get('descriptionSearch') as FormControl;
  }

  ngOnInit() {
    this.brandNameInputOptions.set(
      new InputOptions({
        id: 'brandNameSearch',
        name: 'brandNameSearch',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: this.brandNameSearch,
        onKeyUp: this.onKeyUp
      })
    );

    this.descriptionInputOptions.set(
      new InputOptions({
        id: 'descriptionSearch',
        name: 'descriptionSearch',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: this.descriptionSearch,
        onKeyUp: this.onKeyUp
      })
    );

  this.vaccineSwitchOptions = signal<SwitchOptions>(
      new SwitchOptions({
        id: 'switch',
        label: {
          text: 'brandName',
        },
        value: this.isChecked,
        onInput: (value) => {
          this.isChecked = value;
          console.log('value', value);
          let newSwtOptions = this.vaccineSwitchOptions();
          newSwtOptions.label!.text = value ? 'brandName' : 'description';
          newSwtOptions.value = value;
        },
      })
    );
  }

  onKeyUp = (event: KeyboardEvent, value: string) => {
    console.log('onKeyUp', (event.target as HTMLInputElement).id + ' ' + this.isChecked);
    var api = ((event.target as HTMLInputElement).id === 'brandNameSearch')
      ? this.data().api.brandName
      : this.data().api.description;

    api.body! = {
      description: value
    }

    console.log(this.data().api);
    console.log(api);

    api.body!.description = value;

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.apiService
      .call(api)
      ?.pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) {
          console.log(res);
          res.data.map((item: VaccinationCoding) => {
            item.description = item.display_name;
          })
          this.data().allData.set(res.data);
        }
      });
  }
}
